import { IPromise } from 'angular';

import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { IExtractTaskInfo } from '../models/IExtractTaskInfo';
import { Module } from '../Module';
import { DeleteExtractTasksRequest } from '../ServerApi/requests/DeleteExtractTasksRequest';
import { GetExtractTasksRequest } from '../ServerApi/requests/GetExtractTasksRequest';
import { RunExtractTasksRequest } from '../ServerApi/requests/RunExtractTasksRequest';
import { SetExtractTasksPriorityRequest } from '../ServerApi/requests/SetExtractTasksPriorityRequest';
import { SetExtractTasksScheduleRequest } from '../ServerApi/requests/SetExtractTasksScheduleRequest';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class ExtractTasks extends Resource<IExtractTaskInfo> {

  public static MAX_PRIORITY = 100;
  public static MIN_PRIORITY = 1;

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetExtractTasksRequest,
      ServerApiMapper.extractTasks));
  }

  public del(ids: string[]): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteExtractTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public run(ids: string[]): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new RunExtractTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public setPriority(ids: string[], priority: number): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetExtractTasksPriorityRequest(idsBlock, priority)),
      ResultHelper.combineResults);
  }

  public setSchedule(ids: string[], scheduleId: string) {
    return this.ErrorNotifyingServer.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetExtractTasksScheduleRequest(idsBlock, scheduleId)),
      ResultHelper.combineResults);
  }

}

Module.instance().service('ExtractTasks', ExtractTasks);
